import { FormPayment } from "@/states/service-form/types";

export const PAYMENT_METHOD_REQUIRED_MESSAGE = "支払い方法を選択してください。";
const FREE_SETTLEMENT_METHOD = 0;

export const isPaymentMethodSelectionRequired = (
  finalAmount: number,
  settlementMethod?: number | null,
): boolean => finalAmount > 0 && settlementMethod == null;

export const shouldResetPaymentSelection = (amount: number): boolean =>
  amount > 0;

export const buildPaidPaymentResetPatch = (
  amount: number,
): Pick<FormPayment, "settlementMethod" | "paymentIntentId" | "paymentPayPalId"> => {
  if (!shouldResetPaymentSelection(amount)) {
    return {
      settlementMethod: FREE_SETTLEMENT_METHOD,
      paymentIntentId: undefined,
      paymentPayPalId: undefined,
    };
  }

  return {
    settlementMethod: undefined,
    paymentIntentId: undefined,
    paymentPayPalId: undefined,
  };
};
